export default {
  ROOT: '/',
  SIGNIN: '/signin',
  PLATFORM_SIGNIN: '/signin/platform', // [DEPRECATED] AUTH_SELECTOR 로 대체 (하위 호환을 위해 유지 for TFD 고객센터)
  SSO: '/sso',
  SSO_BY_TICKET: '/sso-by-ticket',
  SSO_BY_TICKET_FOR_WEB_GAME: '/sso-by-ticket-for-web-game',
  SSO_KRPC: '/sso/nxlogin',
  SSO_JPPC: '/sso/jppc',
  SSO_ARENA: '/sso/arena',
  SSO_ARENA_WEST: '/sso/west',
  SSO_ARENA_TH: '/sso/th',
  SSO_ARENA_TW: '/sso/tw',
  SSO_ARENA_SEA: '/sso/sea',
  SSO_ARENA_JP: '/sso/jp',
  SSO_SIMPLE: '/sso/simple',
  SIGNOUT: '/signout',
  SIGNED_OUT: '/signed-out',
  SIGNUP: '/signup',
  SIGNED_UP: '/signed-up',
  ACCOUNT: '/account',
  REDIRECT: '/redirect',
  LOADING: '/loading',
  LINK: '/link',
  LINK_TWITCH: '/link/twitch',
  LINK_CHZZK: '/link/chzzk',
  LINK_DISCOTECH: '/link/discotech',
  OAUTH_AUTHORIZE: '/oauth/authorize',
  LOGIN: '/login',
  LOGOUT: '/logout',
  AUTH_SELECTOR: '/auth-selector',
  LOGIN_SELECTOR: '/login-selector',
  LOGIN_SELECTOR_HEADLESS: '/login-selector/code',
  PLAYNOW_SIGNIN: '/playnow/signin',
  PLAYNOW_SIGNOUT: '/playnow/signout',
  PLAYNOW_CODE: '/playnow/code',
  PLAYNOW_TERMS: '/playnow/terms',
  TOY_TERMS: '/consent/terms',
  ACCOUNT_SETTING: '/setting/account',
  IIV: '/verification/identity',
  SECURITY_CHECK_TURNSTILE: '/security-check/turnstile',
}
